module.exports = __webpack_public_path__ + "static/media/work1.1.2f6c8abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/work1.1.png
// module id = 516
// module chunks = 4